<template>
  <v-card class="pa-4">
    <v-card
      class="justify-center d-flex align-center mb-2"
      height="35"
      width="100%"
      flat
    >
      <h3><strong>Padrão de Calibração</strong></h3>
      <v-btn right absolute small text color="grey" @click="$emit('close')">
        <v-icon small class="mr-1">mdi-close</v-icon>
      </v-btn>
    </v-card>

    <v-divider class="mb-4 mx-3"></v-divider>

    <v-row class="ma-0">
      <v-col cols="12" sm="6" md="4">
        <strong>{{ $t('Equipamento') }}:</strong>
        <label>
          {{ pattern.equipment ? pattern.equipment.name : ' - ' }}
        </label>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <strong>{{ $t('Nome do padrão') }}:</strong>
        <label>
          {{ pattern.name }}
        </label>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <strong>{{ $t('Unidade') }}:</strong>
        <label>
          {{
            pattern.equipment && pattern.equipment.unidade
              ? pattern.equipment.unidade.name
              : ' - '
          }}
        </label>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <strong>{{ $t('Modelo') }}:</strong>
        <label>
          {{ pattern.equipment ? pattern.equipment.model : ' - ' }}
        </label>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <strong>{{ $t('Código de patrimônio') }}:</strong>
        <label>
          {{ pattern.equipment ? pattern.equipment.propertyCode : ' - ' }}
        </label>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <strong>{{ $t('Número de série') }}:</strong>
        <label>
          {{ pattern.equipment ? pattern.equipment.serialNumber : ' - ' }}
        </label>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <strong>{{ $t('Fabricante') }}:</strong>
        <label>
          {{
            pattern.equipment ? pattern.equipment.manufacturer : ' - '
          }}</label
        >
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <strong>Tipo:</strong>
        <label>
          {{
            types.find((x) => x.value == pattern.type)
              ? types.find((x) => x.value == pattern.type).text
              : ' - '
          }}</label
        >
      </v-col>
    </v-row>

    <v-tabs v-model="tab" color="secondary" centered class="mt-4">
      <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">
        Pontos
      </v-tab>
      <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0">
        {{ $t('Migrações') }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <Metrics :patternId="patternId" />
      </v-tab-item>
      <v-tab-item>
        <v-data-table
          :headers="headers"
          :items="migrations"
          class="main-table"
          hide-default-footer
          :items-per-page="migrations.length"
          :loading="loading"
          :header-props="headerProps"
        >
          <template #[`item.date`]="{ item }">
            {{ formatDateTime(item.date) }}
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import utils from '../../../../../Utils/FormatDate'
import Metrics from './metricDetails.vue'

export default {
  name: 'PatternDetail',

  props: {
    patternId: Number,
  },

  components: {
    Metrics,
  },

  data() {
    return {
      tab: null,
      types: [
        {
          text: 'Analisador',
          value: 0,
        },
        {
          text: 'Simulador',
          value: 1,
        },
      ],
      pattern: {},
      apiService: new ApiService(),
      migrations: [],
      loading: false,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      headers: [
        { text: '', align: 'center', value: '', sortable: false },
        {
          text: 'Instituição origem',
          align: 'center',
          value: 'lastInstitution.name',
          sortable: false,
        },
        {
          text: 'Instituição destino',
          align: 'center',
          value: 'institution.name',
          sortable: false,
        },
        {
          text: 'Data',
          align: 'center',
          value: 'date',
          sortable: false,
        },
      ],
    }
  },

  created() {
    this.getPattern()
    this.getMigrations()
  },

  methods: {
    formatDateTime(date) {
      return utils.dateTime(date)
    },

    getPattern() {
      this.apiService
        .get('calibration/v2/pattern/' + this.patternId)
        .then((response) => {
          this.pattern = response.content
        })
    },

    getMigrations() {
      if (this.patternId) {
        this.apiService
          .get('calibration/v2/pattern/migrations/' + this.patternId)
          .then((response) => {
            this.migrations = response.content
            console.log(response)
          })
      }
    },
  },
}
</script>

<style></style>
